import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./redirect.scss";

const RedirectPage = () => {
  const location = useLocation();
  const [isValidUrl, setIsValidUrl] = useState(true);

  // Function to validate URL
  const isValidURL = (string) => {
    try {
      const url = new URL(string);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch (_) {
      return false;
    }
  };

  useEffect(() => {
    // Hide accessibility button with multiple selectors and approaches
    const hideAccessibilityButton = () => {
      // Try multiple selectors that might match the accessibility button
      const selectors = [
        ".btn_accessibility",
        ".accessibility_component",
        ".accessibility_div_wrap",
        'a[role="button"].accessibility_component',
        '[class*="accessibility"]',
        'div[class*="accessibility"]',
      ];

      selectors.forEach((selector) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((element) => {
          element.style.display = "none";
          element.style.visibility = "hidden";
          element.style.opacity = "0";
        });
      });
    };

    // Try to hide immediately and with multiple delays to catch different loading times
    hideAccessibilityButton();
    const timers = [
      setTimeout(hideAccessibilityButton, 100),
      setTimeout(hideAccessibilityButton, 500),
      setTimeout(hideAccessibilityButton, 1000),
      setTimeout(hideAccessibilityButton, 2000),
    ];

    // Extract the 'next' query parameter
    const urlParams = new URLSearchParams(location.search);
    const nextParam = urlParams.get("next");

    // Check if the URL is valid
    if (!nextParam || !isValidURL(nextParam)) {
      setIsValidUrl(false);
    }

    // Cleanup timers on component unmount
    return () => {
      timers.forEach((timer) => clearTimeout(timer));
    };
  }, [location.search]);

  // Get the next parameter for iframe src
  const urlParams = new URLSearchParams(location.search);
  const nextParam = urlParams.get("next");

  return (
    <div className="redirect-page">
      {isValidUrl && nextParam ? (
        <>
          <div className="iframe-container">
            <iframe
              src={nextParam}
              title="Redirected Content"
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation allow-top-navigation-by-user-activation"
            />
          </div>
          <div className="bottom-section">
            <img
              src="/images/all/Betterlogo.svg"
              alt="Better Logo"
              className="better-logo"
            />
          </div>
        </>
      ) : (
        <div className="redirect-container">
          <div className="logo-container">
            <img
              src="/images/all/Betterlogo.svg"
              alt="Better Logo"
              className="better-logo"
            />
          </div>
          <div className="message-container">
            <p className="redirect-message error-message">
              משהו לא עובד כמו שצריך...
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default RedirectPage;
